import { useEffect, useState } from 'react';
import { fetchCardapio, CardapioError, type Cardapio } from '../lib/api';

export type CardapioState =
  | { status: 'loading' }
  | { status: 'ready'; data: Cardapio }
  | { status: 'unavailable' }
  | { status: 'error' };

// Carrega o cardápio de um slug. Recarrega quando o slug muda ou quando `reloadKey`
// é incrementado (botão "tentar de novo"). Cancela a requisição no desmonte /
// troca de slug (AbortController) — StrictMode-safe: o abort não vira estado de erro.
export function useCardapio(slug: string | undefined, reloadKey: number): CardapioState {
  const [state, setState] = useState<CardapioState>({ status: 'loading' });

  useEffect(() => {
    let active = true;
    const controller = new AbortController();
    setState({ status: 'loading' });

    fetchCardapio(slug ?? '', controller.signal)
      .then((data) => {
        if (active) setState({ status: 'ready', data });
      })
      .catch((err: unknown) => {
        if (!active) return;
        // Cancelamento (troca de slug/desmonte): ignora — outro efeito assume.
        if (err instanceof DOMException && err.name === 'AbortError') return;
        if (err instanceof CardapioError && err.kind === 'unavailable') {
          setState({ status: 'unavailable' });
        } else {
          setState({ status: 'error' });
        }
      });

    return () => {
      active = false;
      controller.abort();
    };
  }, [slug, reloadKey]);

  return state;
}
